import { render, staticRenderFns } from "./Orderlicense.vue?vue&type=template&id=b9c796dc&scoped=true&"
import script from "./Orderlicense.vue?vue&type=script&lang=js&"
export * from "./Orderlicense.vue?vue&type=script&lang=js&"
import style0 from "./Orderlicense.vue?vue&type=style&index=0&id=b9c796dc&scoped=true&lang=css&"
import style1 from "./Orderlicense.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c796dc",
  null
  
)

export default component.exports